import { useState, useEffect } from 'react';
import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';
import { toastError } from '@art-of-hospitality-solutions-llc/ui-kit/components/toast';
import BreadcrumbWrapper from '@Components/BreadcrumbWrapper';
import { useNavigate, useParams } from 'react-router-dom';
import service from '../../../service';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/tabs';
import UserRoleForm from '@Views/user-roles/userRoleForm';
import { type UserRole } from '@Types/userRole';
import UserRolePermissionList from './userRolePermissionList';
import UserRoleUserList from './userRoleUserList';

const UserRolesDetails = () => {
  const { userRoleId } = useParams();
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState<UserRole>();
  const [activePermissions, setActivePermissions] = useState([]);
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  const processUserRole = () => {
    const permissionsArray = [];
    const usersArray = [];
    for (const permissionAssignment of userRole.userRolePermissions) {
      permissionsArray.push(permissionAssignment);
    }

    for (const userAssignment of userRole.userAssignments) {
      usersArray.push(userAssignment);
    }

    setActivePermissions(permissionsArray);
    setUsers(usersArray);
  };

  const fetchUserRole = () => {
    service
      .readUserRole(userRoleId)
      .then((userRoleRes) => {
        setUserRole(userRoleRes);
        setLoading(false);
      })
      .catch(() => {
        toastError('Failed to fetch User Roles');
        navigate('/user-roles');
      });
  };

  useEffect(() => {
    fetchUserRole();
  }, [userRoleId]);

  useEffect(() => {
    console.dir(userRole, { depth: null });
    if (userRole && !loading) {
      processUserRole();
    }
  }, [userRole, loading]);

  return (
    <div>
      <BreadcrumbWrapper
        crumbArray={[
          { path: '/user-roles', label: 'User Roles' },
          { path: '/user-roles/*', label: 'User Role Details' },
        ]}
      />

      <div className="mt-4">
        <div className="flex justify-between pb-10">
          <div>
            <Heading>{`${userRole?.name || ''}`}</Heading>
            <Heading styleAs="h6">{`${userRole?.description || ''}`}</Heading>
          </div>

          <UserRoleForm
            edit
            data={{
              id: userRole?.id,
              name: userRole?.name,
              description: userRole?.description,
            }}
          />
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <div>
            <Tabs defaultValue="permissions">
              <TabsList>
                <TabsTrigger value="permissions">Permissions</TabsTrigger>
                <TabsTrigger value="users">Users</TabsTrigger>
              </TabsList>
              <TabsContent value="permissions">
                <UserRolePermissionList
                  activePermissions={activePermissions}
                  fetchUserRole={fetchUserRole}
                  userRoleId={userRoleId}
                />
              </TabsContent>
              <TabsContent value="users">
                <UserRoleUserList
                  fetchUserRole={fetchUserRole}
                  users={users}
                  roleId={userRoleId}
                />
              </TabsContent>
            </Tabs>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserRolesDetails;
